{
	"id": 7504,
	"moduleNumber": 4,
	"title": "The Professional Educator and the School",
	"subtitle": "Balance school culture with ethics by upholding standards, documenting concerns, and protecting students.",
	"kgNodeId": "module-4",
	"moduleKind": "standard",
	"moduleKindLabel": "Lesson",
	"summary": "Module 4 moves from educator-student decisions to school-level ethical obligations. The module centers on a field trip scenario involving educator responsibilities, student supervision, policy expectations, and school-community trust.",
	"estimatedDurationMinutes": 35,
	"activityCount": 2,
	"knowledgeCheck": {
		"included": true,
		"questionCount": 5
	}
}
